import { getAlarmData, getDetectData } from '@/api/stat';
import { isObject, isArray } from '@/utils/is';
import { awaitTo } from '@/utils/utils';
import { getTimestampRange } from '@/utils/date';

const [dayBegin, dayEnd] = getTimestampRange('today');

const [yearBegin, yearEnd] = getTimestampRange('year');

const errLog = (key, err) => console.error(`#[dashboard-${key}]:`, err);

async function extData({ request, busiType, key }) {
  let def = {
    dataList: [],
    dimensions: []
  };

  const [err, res] = await awaitTo(request());

  if (err) {
    errLog(key, err);
    return def;
  }

  if (res && res.data && isObject(res.data[busiType])) {
    def = res.data[busiType];
  } else {
    errLog(key, '数据异常');
  }

  return def;
}

export function getAlarmList() {
  return extData({
    request: () => getAlarmData({ beginTime: dayBegin, endTime: dayEnd, busiType: [0] }),
    busiType: 0,
    key: 'getAlarmList'
  });
}

export function getDetectionList() {
  return extData({
    request: () => getDetectData({ beginTime: dayBegin, endTime: dayEnd, busiType: [0] }),
    busiType: 0,
    key: 'getDetectionList'
  });
}

export function getYearAlarm() {
  return extData({
    request: () => getAlarmData({ beginTime: yearBegin, endTime: yearEnd, busiType: [1] }),
    busiType: 1,
    key: 'getYearAlarm'
  });
}

export function getYearAlarmTrend() {
  return extData({
    request: () => getAlarmData({ beginTime: yearBegin, endTime: yearEnd, busiType: [2] }),
    busiType: 2,
    key: 'getYearAlarmTrend'
  });
}

export function getYearDetection() {
  return extData({
    request: () => getDetectData({ beginTime: yearBegin, endTime: yearEnd, busiType: [21] }),
    busiType: 21,
    key: 'getYearDetection'
  });
}
export function getYearDetectionTrend() {
  return extData({
    request: () => getDetectData({ beginTime: yearBegin, endTime: yearEnd, busiType: [2] }),
    busiType: 2,
    key: 'getYearDetectionTrend'
  });
}

export const getAlarmCount = alarmList => {
  return getCount(alarmList, '报警次数');
};

export const getDetectionCount = detectionList => {
  return getCount(detectionList, '检测次数');
};

function getCount(data, key) {
  if (!data || !isArray(data.dataList)) return 0;
  return data.dataList.reduce((pre, e) => pre + e[key], 0);
}
